// extracted by mini-css-extract-plugin
export var actionButton = "_64-1";
export var actionButtons = "_64-2";
export var actions = "_64-0";
export var aiUnread = "_64-10";
export var alignCenter = "_64-h";
export var backWrapper = "_64-3";
export var cellContainer = "_64-4";
export var checkboxContainer = "_64-5";
export var contentContainer = "_64-6";
export var contentHeader = "_64-8";
export var conversationsTableWrapper = "_64-s";
export var draftReplyBadgeContainer = "_64-m";
export var dropdownItem = "_64-b";
export var dropdownItemsContainer = "_64-a";
export var dropdownTitle = "_64-c";
export var errorIcon = "_64-7";
export var filter = "_64-d";
export var gray = "_64-i";
export var headerActionButtons = "_64-e";
export var headerCheckboxContainer = "_64-f";
export var icon = "_64-j";
export var menuContainer = "_64-k";
export var noMoreTicketsIcon = "_64-12";
export var noMoreTicketsSubText = "_64-13";
export var oneLine = "_64-l";
export var optionsButton = "_64-n";
export var plus = "_64-o";
export var portalButtonsWrapper = "_64-g";
export var red = "_64-p";
export var scrolledTop = "_64-9";
export var search = "_64-q";
export var selectedConversationsCount = "_64-r";
export var spinner = "_64-t";
export var strong = "_64-u";
export var summaryCell = "_64-v";
export var tableContainer = "_64-11";
export var tagContainer = "_64-w";
export var threeDots = "_64-x";
export var twoLines = "_64-y";
export var unread = "_64-z";